export default function () {
  const $selectBoxes = $('.js-select-box');

  $selectBoxes.each(function () {
    const $placeholder = $(this).find('option[disabled]');

    if (!$placeholder.has('[selected]')) {
      $(this).addClass('has-selection');
    }
  });

  $selectBoxes.on('click', function () {
    const optionsArray = this.options;

    if (optionsArray.selectedIndex !== 0) {
      $(this).addClass('has-selection');
    }
  });
}
